import { JetpacB2BApi } from 'api'

class B2bCustomerStatementAPI {
  static getCustomerStatement(
    faberToken: string,
    params?: Record<string, string>
  ) {
    // Build query string if params provided
    const queryString = params
      ? Object.entries(params)
          .filter(([, value]) => value && value.trim() !== '')
          .map(
            ([key, value]) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
          )
          .join('&')
      : ''
    return JetpacB2BApi.httpGet(
      `/invoice${queryString ? `?${queryString}` : ''}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
}

export default B2bCustomerStatementAPI
